// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function getSmartZoom(image) {
  const renderedWidth = image.getBoundingClientRect().width || image.clientWidth || 1;
  const sourceWidth = image.naturalWidth || image.width || renderedWidth;
  const resolutionZoom = sourceWidth / renderedWidth;
  const qualityZoom = Math.min(4, Math.max(2, resolutionZoom));

  return {
    initial: Math.min(2.5, qualityZoom),
    min: 1.5,
    max: 5,
  };
}

function moveWithHover(image, event, zoomRatio, overlay) {
  // Use the real visible zoom surface so every edge remains reachable.
  const container = event.target.getBoundingClientRect();
  const xPosition = Math.min(Math.max(event.clientX - container.left, 0), container.width);
  const yPosition = Math.min(Math.max(event.clientY - container.top, 0), container.height);
  const positionPercent = (position, size) => {
    const percent = (position / size) * 100;

    if (percent <= 2) return 0;
    if (percent >= 98) return 100;
    return percent;
  };
  const xPercent = `${positionPercent(xPosition, container.width)}%`;
  const yPercent = `${positionPercent(yPosition, container.height)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.getBoundingClientRect().width * zoomRatio}px auto`;
  overlay.dataset.zoomLevel = zoomRatio.toFixed(2);
}

function magnify(image) {
  const overlay = createOverlay(image);
  const zoom = getSmartZoom(image);
  let currentZoom = zoom.initial;
  let lastPointerEvent;

  overlay.title = 'Déplacez la souris pour inspecter la carte. Utilisez la molette pour régler le zoom.';
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => {
    lastPointerEvent = event;
    moveWithHover(image, event, currentZoom, overlay);
  };
  overlay.addEventListener(
    'wheel',
    (event) => {
      event.preventDefault();
      currentZoom = Math.min(zoom.max, Math.max(zoom.min, currentZoom + (event.deltaY < 0 ? 0.5 : -0.5)));
      moveWithHover(image, lastPointerEvent || event, currentZoom, overlay);
    },
    { passive: false }
  );

  return { overlay, zoomLevel: currentZoom };
}

function enableZoomOnHover() {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      const smartZoom = magnify(image);
      moveWithHover(image, event, smartZoom.zoomLevel, smartZoom.overlay);
    };
  });
}

enableZoomOnHover();
